<script setup lang="ts">
  import type { EmployerModel } from '@profilpublic/api-contract/employer'
  import { getEmployerCover, getEmployerLogo } from '~/utils/employer'
  import { strapiMedia } from '~/utils/strapi-media'
  import { getEmployerUrl } from '~/utils/url'

  type MediaUrl = { url?: string }

  export type CardEmployerFragment = {
    id: number
    name?: EmployerModel['name']
    slug?: EmployerModel['slug']
    logo?: MediaUrl
    careerSite?: { active?: boolean; slug?: string; cover?: MediaUrl; logo?: MediaUrl }
  }

  const props = defineProps<{
    employer: CardEmployerFragment
  }>()

  const cover = computed(() => getEmployerCover(props.employer))
  const logo = computed(() => getEmployerLogo(props.employer))
</script>

<template>
  <NuxtLink
    class="relative block bg-zinc-300 bg-cover bg-center pt-[56.25%] shadow duration-300 hover:shadow-md"
    :style="{
      backgroundImage: cover?.url ? `url('${strapiMedia(cover.url)}')` : 'images/no-image.webp'
    }"
    :target="employer.careerSite?.active ? '_blank' : undefined"
    :to="getEmployerUrl(employer)"
  >
    <div class="absolute inset-0 flex h-full w-full flex-col items-center justify-center space-y-2 overflow-hidden bg-black/50 p-4">
      <div class="line-clamp-2 text-center font-special font-bold text-white" v-text="employer.name" />
      <div
        class="w-[20%] rounded-full bg-cover bg-center pt-[20%]"
        v-if="logo?.url"
        :style="{
          backgroundImage: `url('${strapiMedia(logo.url)}')`
        }"
      />
    </div>
  </NuxtLink>
</template>
